<template>
  <el-dialog :visible.sync="visible" :before-close="handleClose" width="720px" title="设置">
    <el-form label-width="90px" v-if="specNames && specNames.length">
      <el-form-item label="选择规格：">
        <el-checkbox-group v-model="specIndexes">
          <el-checkbox v-for="(sp, idx) in specNames" :key="idx" :label="idx">{{ sp.name }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="添加前后缀：">
        <div style="display: flex; align-items: center; gap: 8px">
          <el-input v-model="prefix" placeholder="输入前缀" :maxlength="20" @input="onPrefixInput" style="width: 180px">
            <span slot="suffix" style="margin-right: 6px">{{ getBytesCount(prefix) }}/20</span>
          </el-input>
          规格值
          <el-input v-model="suffix" placeholder="输入后缀" :maxlength="20" @input="onSuffixInput" style="width: 180px">
            <span slot="suffix" style="margin-right: 6px">{{ getBytesCount(suffix) }}/20</span>
          </el-input>
        </div>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { getBytesCount } from '@utils/data';
import { cloneDeep } from 'lodash';

export default {
  data() {
    return {
      visible: false,
      specNames: [],
      specIndexes: [],
      prefix: '',
      suffix: '',
      opts: {},
      getBytesCount,
    };
  },
  computed: {
    selectedSpecs() {
      if (!this.specNames || !this.specNames.length) return [];
      return this.specNames.filter((_, idx) => this.specIndexes.includes(idx));
    },
  },
  methods: {
    method_open(opts = {}) {
      this.opts = opts || {};
      this.specNames = cloneDeep(opts.specNames || []);
      this.specIndexes = [];
      this.prefix = '';
      this.suffix = '';
      this.visible = true;
    },
    onPrefixInput(val) {
      this.prefix = this.limitByBytes(val, 20);
    },
    onSuffixInput(val) {
      this.suffix = this.limitByBytes(val, 20);
    },
    limitByBytes(text = '', max = 20) {
      let bytes = 0;
      let out = '';
      for (let i = 0; i < text.length; i++) {
        const code = text.charCodeAt(i);
        const size = (code >= 0x4e00 && code <= 0x9fff) || (code >= 0x3000 && code <= 0x303f) || (code >= 0xff00 && code <= 0xffef) ? 2 : 1;
        if (bytes + size > max) break;
        bytes += size;
        out += text[i];
      }
      return out;
    },
    handleConfirm() {
      if (!this.specIndexes.length) {
        this.$message.warning('请选择规格');
        return;
      }
      if (getBytesCount(this.prefix) > 20 || getBytesCount(this.suffix) > 20) {
        this.$message.warning('前缀/后缀不能超过20个字符');
        return;
      }
      const data = this.selectedSpecs.map(i => {
        return {
          baseItemId: this.opts.baseItemId,
          specificationNameKey: i.nameKey,
          prefix: this.prefix,
          suffix: this.suffix,
        }
      })
      this.opts && this.opts.okFn && this.opts.okFn(data);
      this.handleClose();
    },
    handleClose() {
      this.visible = false;
      this.specNames = [];
      this.specIndexes = [];
      this.prefix = '';
      this.suffix = '';
      this.opts = {};
    },
  },
};
</script>

<style scoped>
</style>
